module.exports = __webpack_public_path__ + "rosywhitey.webp?7f826499d3427fe21b4b3605f488c8cd";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/rosywhitey.webp
// module id = 326
// module chunks = 0